/*-----------------------------------------------------------------
- Comments List
-----------------------------------------------------------------*/
export default {
    no_comment: {
        title      : 'Theoretically not registered!',
        description: 'Record your comment as your first',
    },
};
